<template>
  <div>
    <div ref="reference" class="menu-reference" :class="{ 'is-active': hasActive }" @mouseenter="show" @mouseleave="hide">
      <span>
        <i class="iconfont" :class="`icon-${menu.icon}`" />
        {{ menu.name }}
      </span>
      <i style="float: right;" class="el-icon-arrow-right" />
    </div>
    <div class="menu-sub">
      <div v-for="child in fixedChildren" :key="child.id" class="menu-fixed" :class="{ 'is-active': isActive(child.vueUrl) }" @click="chooseMenu(child)">{{ child.name }}</div>
    </div>
    <transition name="el-fade-in-linear" @after-leave="doDestroy">
      <div v-show="showPopper" ref="popper" class="menu-popper" @mouseenter="show" @mouseleave="hide">
        <div
          v-for="child in children"
          :key="child.id"
          class="menu-child"
          :class="{ 'is-active': isActive(child.vueUrl) }"
          @click="chooseMenu(child)"
        >
          <span>{{ child.name }}</span>
          <i
            class="iconfont icon-suoding fixed-icon"
            style="float: right;"
            :class="{ 'is-fixed': fixedMenus.has(`${child.id}`) }"
            @click.stop="fixedMenuInSideBar(child)"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Popper from 'element-ui/src/utils/vue-popper'
export default {
  mixins: [Popper],
  props: {
    menu: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  computed: {
    children() {
      return this.menu.children || []
    },
    fixedMenus() {
      return new Set(this.$store.getters.fixedMenus)
    },
    fixedChildren() {
      const fixedMenus = this.fixedMenus
      return (this.menu.children || []).filter(menu => fixedMenus.has(`${menu.id}`))
    },
    hasActive() {
      if (!this.menu.vueUrl) return false
      const route = this.$route.matched[1]
      if (!route) return false
      if (route.name === this.menu.vueUrl) return true
      return false
    }
  },
  mounted() {
    this.updatePopper()
  },
  methods: {
    isActive(name) {
      if (!name) return false
      const route = this.$route
      if (name === route.name) return true
      if (name === route.meta.dep) return true
      return false
    },
    show() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.showPopper = true
      }, 250)
    },
    hide() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.showPopper = false
      }, 250)
    },
    chooseMenu(menu) {
      this.showPopper = false
      this.$emit('choose-menu', menu)
    },
    fixedMenuInSideBar(menu) {
      if (this.fixedMenus.has(`${menu.id}`)) {
        this.$store.dispatch('menu/unFixedMenu', menu)
        this.$emit('un-fixed-menu')
      } else {
        this.$store.dispatch('menu/fixedMenu', menu)
        this.$emit('fixed-menu')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  &-reference {
    cursor: pointer;
    padding: 0px 15px;
    color: #999;
    font-size: 14px;
    line-height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover {
      background: #e9f0f5;
      color: #333;
      font-weight: 600;
      .el-icon-arrow-right {
        font-weight: 600;
      }
    }
    &.is-active {
      color: #333;
      font-weight: 600;
      .el-icon-arrow-right {
        font-weight: 600;
      }
    }
  }
  &-popper {
    background: #fff;
    width: 200px;
    box-shadow: 0px 0px 2px 1px #eee;
  }
  &-child {
    cursor: pointer;
    padding: 0px 15px 0px 30px;
    font-size: 12px;
    box-sizing: border-box;
    line-height: 45px;
    color: #999;
    .fixed-icon {
      color: #999;
      display: none;
      font-size: 14px;
      &:hover {
        color: #008ee3;
      }
      &.is-fixed {
        display: inline;
        color: #FF9E00;
      }
    }
    &:hover {
      background: #e9f0f5;
      color: #333;
      .fixed-icon {
        display: inline;
      }
    }
    &.is-active {
      color: #008ee3;
    }
  }

  &-sub {
    padding-left: 32px;
    padding-bottom: 6px;
  }

  &-fixed {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    width: 40%;
    height: 25px;
    overflow: hidden;
    margin-bottom: 5px;
    margin-left: 3px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      color: #5b9bd1;
      font-weight: 600;
    }
    &.is-active {
      color: #008ee3;
      font-weight: 600;
    }
  }
}
</style>
